import PetInsuranceData from "./PetInsuranceData"

export default function() {
    return PetInsuranceData({
        slug: 'hundforsakring-anpassa',
        extraFields: { hunting_dog_supplement: 'Nej' },
        extraPriceFields: ['hunting_dog_supplement'],
        extraWatchFields: ['hunting_dog_supplement'],
    });
}
